import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/src/components/Provider/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/src/context/Middle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/src/QueryProvider.js");
